<template>
    <div>
        <h1 style="font-size: 24px; color: black;">任务管理</h1>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">查询用户 至少填两套 否则不会查询</h2>
            <el-form-item :span="8">
                <span>时间1：</span>
                <el-date-picker
                    v-model="clean.dt1"
                    type="date"
                    :clearable="true"
                    placeholder="可以手填 demo:1991-07-17"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <span>金额1：</span>
                <el-input style="width: 300px" v-model="clean.search1"
                          placeholder="跟时间要么都填要么都别填"></el-input>
            </el-form-item>
            <br>
            <el-form-item :span="8">
                <span>时间2：</span>
                <el-date-picker
                    v-model="clean.dt2"
                    type="date"
                    :clearable="true"
                    placeholder="可以手填 demo:1991-07-17"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <span>金额2：</span>
                <el-input style="width: 300px" v-model="clean.search2"
                          placeholder="跟时间要么都填要么都别填"></el-input>
            </el-form-item>
            <br>
            <el-form-item :span="8">
                <span>时间3：</span>
                <el-date-picker
                    v-model="clean.dt3"
                    type="date"
                    :clearable="true"
                    placeholder="可以手填 demo:1991-07-17"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <span>金额3：</span>
                <el-input style="width: 300px" v-model="clean.search3"
                          placeholder="跟时间要么都填要么都别填"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="searchBill">查询</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">删除用户</h2>
            <el-form-item label="用户nickId：">
                <el-input style="width: 300px" placeholder="用小写的逗号分割" v-model="clean.nickIds"></el-input>
            </el-form-item>
            <el-form-item label="删除结果：">
                <el-input style="width: 300px" placeholder="删除结果" v-model="clean.result"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="cleanF">删除</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">账单、账本、资产、分类、预算迁移（不包括共享账本）</h2>
            <el-form-item label="fromNickId：">
                <el-input style="width: 300px" v-model="clean.fromNickId"></el-input>
            </el-form-item>
            <el-form-item label="toNickId：">
                <el-input style="width: 300px" v-model="clean.toNickId"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="trans">迁移</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">会员</h2>
            <el-form-item label="nickId：">
                <el-input style="width: 300px" v-model="clean.nickId"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="queryUser">查询</el-button>
                <el-form-item label="开通类型 :" :label-width="labelWidth">
                    <el-select v-model="clean.vipType" placeholder="请选择">
                        <el-option
                            v-for="item in iosBookTaskSelections.vipTypeTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开通时长 :" :label-width="labelWidth">
                    <el-select v-model="clean.vip" placeholder="请选择">
                        <el-option
                            v-for="item in iosBookTaskSelections.vipTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button class="sub-sub" type="primary" @click="vip(0)">开通</el-button>
                <el-button class="sub-sub" type="primary" @click="vip(1)">取消</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">绑定</h2>
            <el-form-item label="nickId：">
                <el-input style="width: 300px" v-model="clean.nickIdBind"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="sub-sub" type="primary" @click="queryUserBind">查询</el-button>
                <el-form-item label="绑定类型 :" :label-width="labelWidth">
                    <el-select v-model="clean.bindType" placeholder="请选择">
                        <el-option
                            v-for="item in bindTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button class="sub-sub" type="primary" @click="unbind">解绑</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">加金币</h2>
            <el-form-item label="nickId：">
                <el-input style="width: 300px" v-model="clean.coinNickId"></el-input>
            </el-form-item>
            <el-button class="sub-sub" type="primary" @click="queryCoin">查询</el-button>
            <el-form-item>
                <el-form-item label="金币数：">
                    <el-input style="width: 300px" v-model="clean.coinAdd"></el-input>
                </el-form-item>

                <el-button class="sub-sub" type="primary" @click="addCoin">增加</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">恢复账本</h2>
            <el-form-item label="nickId：">
                <el-input style="width: 300px" v-model="clean.ledgerNickId"></el-input>
            </el-form-item>
            <el-button class="sub-sub" type="primary" @click="queryLedger">查询</el-button>
            <el-form-item>
                <el-form-item label="账本id：">
                    <el-input style="width: 300px" v-model="clean.ledgerId"></el-input>
                </el-form-item>

                <el-button class="sub-sub" type="primary" @click="updateLedger">恢复</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="clean" size="small" label-width="120px">
            <h2 style="color: red">恢复资产</h2>
            <el-form-item label="nickId：">
                <el-input style="width: 300px" v-model="clean.assertNickId"></el-input>
            </el-form-item>
            <el-button class="sub-sub" type="primary" @click="queryAssert">查询</el-button>
            <el-form-item>
                <el-form-item label="资产id：">
                    <el-input style="width: 300px" v-model="clean.assertId"></el-input>
                </el-form-item>

                <el-button class="sub-sub" type="primary" @click="updateAssert">恢复</el-button>
            </el-form-item>
        </el-form>

        <el-tabs type="card" v-model="selectedTaskType" @tab-click="changeTaskType">
            <el-tab-pane v-for="item in iosBookTaskSelections.taskTypes" :name="item.id+'' " :key="item.id"
                         :label="item.name">
            </el-tab-pane>
        </el-tabs>
        <el-button type="primary" @click="showDetails('添加任务')">添加</el-button>
        <h1>
            <el-table :data="list" border>
                <el-table-column label="任务ID" prop="id" align="center"></el-table-column>
                <el-table-column label="任务名称" prop="name" align="center"></el-table-column>
                <el-table-column label="任务标题" prop="title" align="center"></el-table-column>
                <el-table-column label="奖励" align="center" prop="rewards">
                    <template slot-scope="scope">
                        {{ scope.row.rewards | iosRewardFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="领取类型" prop="obtainType.name" align="center"></el-table-column>
                <el-table-column label="排序" prop="ranking" align="center"></el-table-column>
                <el-table-column label="是否有列表广告" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.ad ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="是否有独立广告" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.adAgain ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.state === 1" type="success" size="small" plain
                                   @click="updateState(scope.row)">正常
                        </el-button>
                        <el-button v-if="scope.row.state === 0" type="danger" size="small" plain
                                   @click="updateState(scope.row)">关闭
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建日期" prop="createDt" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="更新日期" prop="updateDt" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.updateDt | dateTimeFormat }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑任务',scope.row)">编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10,20,30]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="page.totalElements">
        </el-pagination>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="taskForm">
                <el-form-item label="任务名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.name" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="任务描述 :" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.title" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="描述图片" :label-width="labelWidth">
                    <el-upload
                        :headers="headers"
                        :action="uploadURL"
                        list-type="picture-card"
                        :on-success="handleImageSuccess0"
                        :on-remove="handleImgRemove0"
                        :before-upload="beforeAvatarUpload"
                        limit="1"
                        :file-list="fileList0">
                        <i class="el-icon-plus"></i>
                        <el-alert slot="tip"
                                  title="上传成功画框会有绿色对钩标识，视频组件不支持内容回显"
                                  type="success"
                                  center
                                  show-icon>
                        </el-alert>
                    </el-upload>
                </el-form-item>
                <el-form-item label="状态 :" :label-width="labelWidth">
                    <el-radio-group v-model="taskForm.state">
                        <el-radio :label="1">开始</el-radio>
                        <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否有列表广告:" :label-width="labelWidth">
                    <el-switch v-model="taskForm.ad"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="是否有独立广告:" :label-width="labelWidth">
                    <el-switch v-model="taskForm.adAgain"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="排序" :label-width="labelWidth">
                    <el-input type="text" v-model="taskForm.ranking"
                              onkeyup="this.value=this.value.replace(/\D/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="领取类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.obtainType" placeholder="请选择">
                        <el-option
                            v-for="item in iosBookTaskSelections.obtainTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖励类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.rewardType" placeholder="请选择">
                        <el-option
                            v-for="item in iosBookTaskSelections.rewardTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务类型 :" :label-width="labelWidth">
                    <el-select v-model="taskForm.achieveType" placeholder="请选择">
                        <el-option
                            v-for="item in iosBookTaskSelections.achieveTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="达成条件数 :" :label-width="labelWidth">
                    <el-input-number size="mini" :min="1" v-model="taskForm.number"></el-input-number>
                </el-form-item>
                <el-form-item :label-width="labelWidth">
                    <el-button size="mini" type="primary" @click="addGoods">新增奖励</el-button>
                    <el-table :data="taskForm.goodsList"
                              border
                              :fit="true">
                        <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
                        <el-table-column label="奖励" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.goodsId" placeholder="请选择">
                                    <el-option
                                        v-for="item in goods"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="奖励数量" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.number"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80px">
                            <template slot-scope="scope">
                                <el-button circle icon="el-icon-minus" size="mini" type="danger"
                                           @click.native.prevent="reduceGoods(scope.$index,taskForm.goodsList)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item :label-width="labelWidth" v-if="taskForm.rewardType===2">
                    <el-button size="mini" type="primary" @click="addProbability">新增随机奖励</el-button>
                    <el-table :data="taskForm.probabilityList"
                              border
                              :fit="true">
                        <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
                        <el-table-column label="随机奖励数量" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.number"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="随机概率" align="center">
                            <template slot-scope="scope">
                                <el-input-number size="mini" :min="1" v-model="scope.row.probability"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="80px">
                            <template slot-scope="scope">
                                <el-button circle icon="el-icon-minus" size="mini" type="danger"
                                           @click.native.prevent="reduceProbability(scope.$index,taskForm.probabilityList)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="奖励图片" :label-width="labelWidth">
                    <el-upload
                        :headers="headers"
                        :action="uploadURL"
                        list-type="picture-card"
                        :on-success="handleImageSuccess1"
                        :on-remove="handleImgRemove1"
                        :before-upload="beforeAvatarUpload"
                        limit="1"
                        :file-list="fileList1">
                        <i class="el-icon-plus"></i>
                        <el-alert slot="tip"
                                  title="上传成功画框会有绿色对钩标识，视频组件不支持内容回显"
                                  type="success"
                                  center
                                  show-icon>
                        </el-alert>
                    </el-upload>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm">提 交</el-button>
                    <el-button type="info" @click="cancelForm">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import {clean, goodsSelections, saveTask, searchTask, updateTaskState} from "@/http/iosBookApi";
import store from '@/store';
import settingMix from '@/utils/mix/common-setting';
import {addCoin, bind, getUser, queryCoin, trans, unbind, vip} from "@/http/iosBookUserApi";
import {searchAssert, searchBill, searchLedger, updateAssert, updateLedger} from "../../../http/iosBookUserApi";

export default {
    name: "IosBookTaskManage",
    mixins: [settingMix],
    data() {
        return {
            VUE_APP_IOS_URL: '',
            VUE_APP_CDN_URL: '',
            selectedTaskType: "",
            needIosBookTaskSelections: true,
            uploadURL: process.env.VUE_APP_IOS_BOOK_URL + "file/upload/good",
            labelWidth: '110px',
            headers: {},
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
            list: [],
            queryData: {
                "orders": "id asc ",
            },
            goods: [],
            iosBookTaskSelections: {},
            dialogTitle: '',
            dialogVisible: false,
            taskForm: {},
            fileList: [],
            fileList0: [],
            fileList1: [],
            clean: {
                ids: ',',
                nickIds: ',',
                result: '',
                fromNickId: '',
                toNickId: '',
                nickId: '',
                vipType: 0,
                vip: 0,
                coinNickId: '',
                coinAdd: '',
                nickIdBind: '',
                bindType: '',
                dt1: '',
                search1: '',
                dt2: '',
                search2: '',
                dt3: '',
                search3: '',
                ledgerNickId: '',
                ledgerId: '',
                assertNickId: '',
                assertId: '',
            },
            bindTypes: [{
                id: 1,
                name: '微信'
            }, {
                id: 2,
                name: 'qq'
            }, {
                id: 3,
                name: '苹果'
            }, {
                id: 11,
                name: '手机号'
            }, {
                id: 12,
                name: '华为'
            }]
        }
    },
    methods: {
        changeTaskType(tab) {
            this.$store.commit('changeSelectedTaskType', tab.name);
            this.selectedTaskType = tab.name;
            //this.addTaskForm.taskType= tab.name;
            this.page.page = 1;
            this.search();
        },
        search() {
            this.queryData.taskType = parseInt(this.selectedTaskType);
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchTask(this.queryData).then(resp => {
                this.list = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements
            })
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.search();
        },
        handleImageSuccess0(response) {
            const temp = {name: null, url: null, postUrl: null};
            const url = response.info;
            const array = url.split('/');
            temp.name = array[array.length - 1];
            //这里拼接对象进去   获取展示数据的时候可能需要解析数组 提交数据的时候需要组合数组
            temp.url = process.env.VUE_APP_CDN_URL + url;
            temp.postUrl = url;
            this.fileList[0] = temp;
        },
        handleImgRemove0(file) {
            this.fileList[0] = null;
        },
        handleImageSuccess1(response) {
            const temp = {name: null, url: null, postUrl: null};
            const url = response.info;
            const array = url.split('/');
            temp.name = array[array.length - 1];
            //这里拼接对象进去   获取展示数据的时候可能需要解析数组 提交数据的时候需要组合数组
            temp.url = process.env.VUE_APP_CDN_URL + url;
            temp.postUrl = url;
            this.fileList[1] = temp;
        },
        handleImgRemove1(file) {
            this.fileList[1] = null;
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isGif = file.type === "image/gif";
            const isMp4 = file.type === "video/mp4";
            const isPG = isJPG || isPNG || isGif;
            if (isPG) {
                //限制图片格式为jpg / png
                if (file.size / 1024 / 1024 > 1) {
                    this.$message.error("上传图片应该小于1M，请重新上传");
                    return false;
                }
            } else if (isMp4) {
                if (file.size / 1024 / 1024 > 5) {
                    this.$message.error("上传视频应该小于5M，请重新上传");
                    return false;
                }
            }
        },
        updateState(row) {
            this.$confirm('此操作将关闭任务, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let taskId = row.id;
                let state = row.state === 0 ? 1 : 0;
                updateTaskState(taskId, state).then(resp => {
                    if (resp.data.status === 1) {
                        this.search();
                    }
                })
            }).catch(() => {
            })
        },
        goodsSelections() {
            goodsSelections().then(resp => {
                this.goods = resp.data.info;
            })
        },
        showDetails(title, row) {
            this.goodsSelections();
            this.taskForm = {
                "id": 0,
                "name": "",
                "title": "",
                "state": 1,
                "number": 1,
                "ad": false,
                "adAgain": false,
                "ranking": 1,
                "taskType": this.selectedTaskType,
                "obtainType": 1,
                "rewardType": 1,
                "achieveType": 1,
                "goodsList": [],
                "probabilityList": [],
            };
            this.dialogTitle = title;
            this.dialogVisible = true;

            function chargeReward(list) {
                let newRewards = [];
                list.forEach((item) => {
                    newRewards.push({
                        goodsId: item.goods.id,
                        number: item.number
                    })
                });
                return newRewards
            }

            function chargePro(list) {
                let newProbability = [];
                list.forEach((item) => {
                    newProbability.push({
                        number: item.number,
                        probability: item.probability
                    })
                });
                return newProbability
            }

            function chargeImage(image) {
                let file = [];
                let list = image.split(",");
                list.forEach((item) => {
                    const temp = {name: null, url: null, postUrl: null};
                    const url = item;
                    const array = url.split('/');
                    temp.name = array[array.length - 1];
                    temp.url = process.env.VUE_APP_CDN_URL + url;
                    temp.postUrl = url;
                    file.push(temp)
                });
                return file;
            }

            if (row) {
                this.taskForm = {
                    "id": row.id,
                    "name": row.name,
                    "title": row.title,
                    "ranking": row.ranking,
                    "ad": row.ad,
                    "adAgain": row.adAgain,
                    "state": row.state,
                    "number": row.number,
                    "taskType": row.taskType,
                    "obtainType": row.obtainType.id,
                    "rewardType": row.rewardType.id,
                    "achieveType": row.achieveType.id,
                    "goodsList": chargeReward(row.rewards),
                    "probabilityList": chargePro(row.probabilities)
                };
                this.fileList0 = [chargeImage(row.image)[0]];
                this.fileList1 = [chargeImage(row.image)[1]];
                this.fileList = [this.fileList0[0], this.fileList1[0]]
            }
        },
        cleanF() {
            clean(this.clean.ids, this.clean.nickIds).then(resp => {
                this.clean.result = resp.data.msg;
            })
        },
        searchBill() {
            searchBill(this.clean).then(resp => {
                // 取出所有需要展示的 key：123、12、13、23
                const data = resp.data.info;
                const keys = ["user123", "user12", "user13", "user23"];
                let html = `<div style="font-size:14px;line-height:1.6;">`;

                // 遍历每个分组
                keys.forEach(key => {
                    const list = data[key] || [];
                    if (list.length === 0) return;

                    // 展示标题：user123 / user12 / user13 / user23
                    html += `<div style="margin:10px 0;font-weight:bold;color:#2f7bf5;">${key} 共${list.length}条</div>`;

                    // 展示每条数据
                    list.forEach((item, idx) => {
                        html += `
                <div style="background:#f7f9fc;padding:8px 12px;border-radius:8px;margin-bottom:8px;">
                    <div>序号：${idx + 1}</div>
                    <div>昵称ID：${item.nickId}</div>
                    <div>名称：${item.name}</div>
                </div>`;
                    });
                });

                html += `</div>`;

                // 优雅弹窗（自定义蒙层 + 居中卡片样式）
                const layer = document.createElement("div");
                layer.style.cssText = `
            position:fixed;left:0;top:0;right:0;bottom:0;
            background:rgba(0,0,0,0.5);z-index:9999;
            display:flex;align-items:center;justify-content:center;
        `;
                const box = document.createElement("div");
                box.style.cssText = `
            background:#fff;max-width:380px;width:90%;
            border-radius:12px;overflow:hidden;
            padding:15px 20px;max-height:80vh;overflow-y:auto;
        `;
                box.innerHTML = html;
                layer.appendChild(box);
                document.body.appendChild(layer);

                // 点击蒙层关闭
                layer.onclick = (e) => {
                    if (e.target === layer) {
                        document.body.removeChild(layer);
                    }
                };
            });
        },
        trans() {
            // 第一步：先统一 nickId 类型（转成数字，和接口返回一致）
            const fromNickId = Number(this.clean.fromNickId) || 0;
            const toNickId = Number(this.clean.toNickId) || 0;

            // 验证参数有效性
            if (!fromNickId || !toNickId) {
                alert('来源或目标 nickId 无效！');
                console.error('无效 nickId：', 'fromNickId=', fromNickId, 'toNickId=', toNickId);
                return;
            }

            console.log('===== 类型统一后参数 =====');
            console.log('fromNickId（数字）：', fromNickId);
            console.log('toNickId（数字）：', toNickId);

            // 第二步：并行请求（去掉多余过滤，直接取数组中所有 name）
            Promise.all([
                getUser(fromNickId).catch(err => {
                    console.error('获取来源用户失败：', err);
                    return {data: {info: []}};
                }),
                getUser(toNickId).catch(err => {
                    console.error('获取目标用户失败：', err);
                    return {data: {info: []}};
                })
            ]).then(([fromResp, toResp]) => {
                // 直接提取数组（接口已确认返回数组）
                const fromList = fromResp.data?.info || [];
                const toList = toResp.data?.info || [];

                console.log('===== 接口返回数组 =====');
                console.log('fromList 长度：', fromList.length, ' 数据：', fromList);
                console.log('toList 长度：', toList.length, ' 数据：', toList);

                // 第三步：【只改这里！】只匹配 nickId 完全相同的用户
                const fromNames = fromList
                    .filter(item => Number(item.nickId) === fromNickId) // 只保留相同nickId
                    .map(item => item?.name || '未知名称')
                    .join('、') || '无来源用户';

                const toNames = toList
                    .filter(item => Number(item.nickId) === toNickId) // 只保留相同nickId
                    .map(item => item?.name || '未知名称')
                    .join('、') || '无目标用户';

                console.log('===== 最终拼接结果 =====');
                console.log('fromNames：', fromNames);
                console.log('toNames：', toNames);

                const msg = `from=${fromNames}，to=${toNames}`;
                alert('确认框消息：' + msg);

                // 确认框逻辑
                this.$confirm(msg, '必须先确认昵称', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    trans(fromNickId, toNickId)
                        .then(resp => alert(resp.data.msg || '操作成功'))
                        .catch(err => {
                            console.error('转账失败：', err);
                            alert('操作失败，请稍后重试');
                        });
                }).catch(() => console.log('用户取消确认'));
            }).catch(err => {
                console.error('整体流程异常：', err);
                alert('系统异常，请稍后重试');
            });
        },
        queryUser() {
            getUser(this.clean.nickId).then(resp => {
                if (resp.data.status === 0) {
                    // 美化排版：HTML 格式，整齐干净
                    let msg = "";
                    for (let x in resp.data.info) {
                        const item = resp.data.info[x];
                        msg += `
                <div style="margin-bottom:12px;">
                    <div>昵称：${item.name}</div>
                    <div>nickId：${item.nickId}</div>
                    <div>记账笔数：${item.billRecordCount}</div>
                    <div>普通VIP：${item.normalVipDt}</div>
                    <div>免广告VIP：${item.adVipDt}</div>
                    <div>邀请VIP：${item.visitVipDt}</div>
                    <div>设备码：${item.deviceCode}</div>
                </div>
                <hr style="border:none;border-bottom:1px solid #eee;margin:10px 0;">
            `;
                    }

                    // 用 ElementUI 美化弹窗，永久显示 + 支持 HTML + 关闭按钮
                    this.$alert(msg, '用户详情信息', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '关闭',
                        closeOnClickModal: false,
                        showClose: true
                    });
                } else {
                    this.$message.error(resp.data.msg);
                }
            })
        },
        queryUserBind() {
            bind(this.clean.nickIdBind).then(resp => {
                if (resp.data.status === 0) {
                    // 美化排版：HTML 格式，整齐干净
                    let msg = "";
                    for (let x in resp.data.info) {
                        const item = resp.data.info[x];
                        msg += `
                <div style="margin-bottom:12px;">
                    <div>昵称：${item.name}</div>
                    <div>类型：${item.type}</div>
                </div>
                <hr style="border:none;border-bottom:1px solid #eee;margin:10px 0;">
            `;
                    }

                    // 用 ElementUI 美化弹窗，永久显示 + 支持 HTML + 关闭按钮
                    this.$alert(msg, '用户详情信息', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '关闭',
                        closeOnClickModal: false,
                        showClose: true
                    });
                } else {
                    this.$message.error(resp.data.msg);
                }
            })
        },
        unbind() {
            unbind(this.clean.nickIdBind, this.clean.bindType).then(resp => {
                if (resp.data.status === 0) {
                    this.queryUserBind(this.clean.nickIdBind)
                } else {
                    alert(resp.data.msg)
                }
            })
        },
        vip(event) {
            vip(this.clean.nickId, this.clean.vipType, this.clean.vip, event, store.state.user.account).then(resp => {
                if (resp.data.status === 0) {
                    alert("昵称=" + resp.data.info.name + "\n普通vip截止日期=" + resp.data.info.normalVipDt + "\n免广告vip截止日期=" + resp.data.info.adVipDt + "\n邀请vip截止日期=" + resp.data.info.visitVipDt)
                } else {
                    alert(resp.data.msg)
                }
            })
        },
        queryCoin() {
            queryCoin(this.clean.coinNickId).then(resp => {
                alert("昵称=" + resp.data.info.name + "\n金币数=" + resp.data.info.coin)
            })
        },
        addCoin() {
            addCoin(this.clean.coinNickId, this.clean.coinAdd).then(resp => {
                alert("昵称=" + resp.data.info.name + "\n金币数=" + resp.data.info.coin)
            })
        },
        queryLedger() {
            var req = {
                nickId: this.clean.ledgerNickId
            }
            searchLedger(req).then(resp => {
                if (resp.data.status === 0) {
                    // 美化排版：HTML 格式，整齐干净
                    let msg = "";
                    for (let x in resp.data.info.list) {
                        const item = resp.data.info.list[x];
                        msg += `
                <div style="margin-bottom:12px;">
                    <div>id：${item.id}</div>
                    <div>名称：${item.name}</div>
                    <div>是否删除：${item.isDelete}</div>
                </div>
                <hr style="border:none;border-bottom:1px solid #eee;margin:10px 0;">
            `;
                    }

                    // 用 ElementUI 美化弹窗，永久显示 + 支持 HTML + 关闭按钮
                    this.$alert(msg, '用户详情信息', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '关闭',
                        closeOnClickModal: false,
                        showClose: true
                    });
                } else {
                    this.$message.error(resp.data.msg);
                }
            })
        },
        updateLedger() {
            var req = {
                nickId: this.clean.ledgerNickId,
                ledgerId: this.clean.ledgerId,
            }
            updateLedger(req).then(resp => {
                if (resp.data.status === 0) {
                    alert("成功")
                } else {
                    alert(resp.data.msg)
                }
            })
        },
        updateAssert() {
            var req = {
                nickId: this.clean.assertNickId,
                assertId: this.clean.assertId,
            }
            updateAssert(req).then(resp => {
                if (resp.data.status === 0) {
                    alert("成功")
                } else {
                    alert(resp.data.msg)
                }
            })
        },
        queryAssert() {
            var req = {
                nickId: this.clean.assertNickId
            }
            searchAssert(req).then(resp => {
                if (resp.data.status === 0) {
                    // 美化排版：HTML 格式，整齐干净
                    let msg = "";
                    for (let x in resp.data.info.list) {
                        const item = resp.data.info.list[x];
                        msg += `
                <div style="margin-bottom:12px;">
                    <div>id：${item.id}</div>
                    <div>名称：${item.accountName}</div>
                    <div>amount：${item.amount}</div>
                    <div>是否删除：${item.isDelete}</div>
                </div>
                <hr style="border:none;border-bottom:1px solid #eee;margin:10px 0;">
            `;
                    }

                    // 用 ElementUI 美化弹窗，永久显示 + 支持 HTML + 关闭按钮
                    this.$alert(msg, '用户详情信息', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '关闭',
                        closeOnClickModal: false,
                        showClose: true
                    });
                } else {
                    this.$message.error(resp.data.msg);
                }
            })
        },
        addGoods() {
            this.taskForm.goodsList.push({
                goodsId: 1,
                number: 0
            })
        },
        reduceGoods(index, rows) {
            rows.splice(index, 1);
        },
        addProbability() {
            this.taskForm.probabilityList.push({
                number: 0,
                probability: 20
            })
        },
        reduceProbability(index, rows) {
            rows.splice(index, 1);
        },
        confirmForm() {
            let _message = '';
            if (this.taskForm.name === '') {
                _message = '请输入策略名称'
            } else if (this.taskForm.goodsList.length < 1) {
                _message = '请添加奖励配置'
            } else if (this.taskForm.rewardType === 2 && this.taskForm.goodsList.length < this.taskForm.probabilityList.length) {
                _message = '随机奖励不能超过奖品数'
            } else if (this.taskForm.rewardType === 2 && this.taskForm.probabilityList.length < 1) {
                _message = '请添加随机奖励配置'
            }
                // else if (isRepeat(this.taskForm.goodsList)){
                //     _message = '请勿重复配置奖品'
            // }
            else if (this.taskForm.rewardType === 2 && isFull(this.taskForm.probabilityList)) {
                _message = '请达到百分百'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }

            function isRepeat(list) {
                let ids = [];
                list.forEach((item) => {
                    ids.push(item.goodsId)
                });
                var set = new Set(ids);
                return ids.length !== set.size;
            }

            function isFull(list) {
                let num = 0;
                list.forEach((item) => {
                    num += item.probability
                });
                return num !== 100;
            }

            function transImage(list) {
                let url = [];
                list.forEach((item) => {
                    if (item != null) {
                        url.push(item.postUrl)
                    }
                });
                return url;
            }

            this.taskForm.image = transImage(this.fileList);
            saveTask(this.taskForm).then(resp => {
                if (resp.data.status === 0) {
                    this.search();
                    this.dialogVisible = false;
                }
            });
        },
        cancelForm() {
            this.dialogVisible = false;
            this.fileList = [];
        }
    },
    mounted() {
        this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_BOOK_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    },
    created() {
        this.headers = {Authorization: this.$store.state.user.token};
        this.selectedTaskType = store.state.newProjectVersion.selectedTaskType,
            this.search();
    }
}
</script>

<style scoped>

</style>
